module.exports = __webpack_public_path__ + "img/appointments.ab282d03.svg";